// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__59y9M","link":"styles_link__Riss7","author_text":"styles_author_text__GXuL7","image_wrapper":"styles_image_wrapper__bujMk"};